import { render, staticRenderFns } from "./RepaymentTable.vue?vue&type=template&id=18db794a&scoped=true&"
import script from "./RepaymentTable.vue?vue&type=script&lang=js&"
export * from "./RepaymentTable.vue?vue&type=script&lang=js&"
import style0 from "./RepaymentTable.vue?vue&type=style&index=0&id=18db794a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18db794a",
  null
  
)

export default component.exports